import { getCookies, setCookie } from 'lib/web/cookieUtils'

const CART_AUTO_DROPDOWN_SUPPRESSED_KEY = 'cartAutoDropdownSuppressed'

const ONE_DAY_IN_SECONDS = 24 * 60 * 60

export function isCartAutoPreviewDropdownSuppressed(): boolean {
  const cookies = getCookies()
  return cookies[CART_AUTO_DROPDOWN_SUPPRESSED_KEY] === 'true'
}

export function suppressCartAutoDropdown(): void {
  setCookie(CART_AUTO_DROPDOWN_SUPPRESSED_KEY, 'true', ONE_DAY_IN_SECONDS, '/', 'Lax')
}
